import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../state/context';
import { Link, Redirect } from 'react-router-dom';
import useFetch from "../../api/fetch";

import LoginForm from '../../components/login-form/login-form.component';

export default function LoginPage() {
    const { dispatch, state } = useContext(Context);

    const [authKey, setAuthKey] = useState('');
    const [error, setError] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const fetch = useFetch();

    useEffect(() => {
        if (state.authKey !== null) {
            setAuthKey(state.authKey)
        } else {
            setAuthKey(false);
        }
    }, [state.authKey])

    const handleSubmit = async (user, password) => {

        const data = new FormData()
        data.set('username', user)
        data.set('password', password)

        const { error, success, key, roles, ul } = await fetch(`/api/login`, {
            method: 'POST',
            body: data
        }).then(x => x.json())

        setError(error)

        if (error || !success) {
            return
        }

        localStorage.setItem('auth_key', key)
        localStorage.setItem('roles', JSON.stringify(roles))
        localStorage.setItem('userLanguages', JSON.stringify(ul))

        let language = ul[0]
        dispatch({
            type: 'SET_AUTH_KEY',
            key
        })
        dispatch({
            type: 'SET_ROLES',
            roles
        })
        dispatch({
            type: 'SET_LANGUAGE',
            language: language
        })

        setRedirect(true)
    }

    const handleLogout = () => {
        localStorage.removeItem('auth_key')
        localStorage.removeItem('roles')
        localStorage.removeItem('userLanguages')

        dispatch({
            type: 'SET_AUTH_KEY',
            authKey: ''
        })
        dispatch({
            type: 'SET_ROLES',
            roles: []
        })
        dispatch({
            type: 'SET_LANGUAGE',
            language: ''
        })
    }

    return (
        <div className={'container mt-4'}>
            <div className={'row'}>
                <div className={'col-lg'} />
                <div className={'col-lg'}>
                    {!authKey && <>
                        {error && <div className={'alert alert-danger'}>
                            <b>Error:</b> Incorrect credentials
                        </div>}
                        <LoginForm onSubmit={handleSubmit} />
                    </>}
                    {authKey && <>
                        <p>You are logged in!</p>
                        <div><Link className={'d-block btn btn-primary btn-block'} to={'/'}>Go to Home</Link></div>
                        <br />
                        <div>
                            <button className={'btn btn-primary btn-warning btn-block'} onClick={handleLogout}>Log out</button>
                        </div>
                    </>}
                </div>
                <div className={'col-lg'} />
            </div>
            {redirect && <Redirect to={'/'} />}
        </div>
    )
}
